import React from 'react';
export function Divider() {
  return <div className="flex items-center gap-4 my-10" data-id="element-8">
      <div className="flex-1 h-px bg-border" data-id="element-9"></div>
      <div className="w-1.5 h-1.5 rounded-full bg-teal" data-id="element-10"></div>
      <div className="flex-1 h-px bg-border" data-id="element-11"></div>
    </div>;
}